import { createContext, useCallback, useContext, useRef, useState, type ReactNode } from 'react';

type Tone = 'info' | 'error';
/** Ação opcional no aviso (ex.: "Desfazer"); o aviso fica mais tempo na tela quando tem ação. */
export interface ToastAction { label: string; onClick: () => void }
const Ctx = createContext<(msg: string, tone?: Tone, label?: string, action?: ToastAction) => void>(() => {});

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toast, setToast] = useState<{ msg: string; tone: Tone; label: string; show: boolean; action?: ToastAction }>({ msg: '', tone: 'info', label: '', show: false });
  const timer = useRef<number | undefined>(undefined);
  const show = useCallback((msg: string, tone: Tone = 'info', label = tone === 'error' ? 'Atenção:' : 'InteliMove:', action?: ToastAction) => {
    setToast({ msg, tone, label, show: true, action });
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setToast((t) => ({ ...t, show: false })), action ? 8000 : 3200);
  }, []);
  return (
    <Ctx.Provider value={show}>
      {children}
      <div className={`toast ${toast.show ? 'show' : ''} ${toast.tone === 'error' ? 'error' : ''}`} role="status" aria-live="polite">
        {toast.msg && <><b>{toast.label}</b> {toast.msg}</>}
        {toast.show && toast.action && (
          <button type="button" className="toast-action" onClick={() => { const a = toast.action!; setToast((t) => ({ ...t, show: false })); a.onClick(); }}>{toast.action.label}</button>
        )}
      </div>
    </Ctx.Provider>
  );
}

export const useToast = () => useContext(Ctx);
